import { motion } from "framer-motion";
import { OBJECTIVES, PDF_BG } from "../data/content";
import SectionBg from "./SectionBg";

export default function Objectives() {
    return (
        <section
            id="objectives"
            className="relative py-24 md:py-40 overflow-hidden"
            data-testid="objectives-section"
        >
            <SectionBg src={PDF_BG.objectives} opacity={0.6} />
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-12 md:mb-16">
                    <div className="col-span-12 md:col-span-4 text-xs uppercase tracking-[0.3em] text-[#FF6B35] font-mono">
                        Why We Exist
                    </div>
                    <h2 className="col-span-12 md:col-span-8 min-w-0 max-w-full font-display font-bold text-[1.62rem] leading-[1.14] tracking-normal break-words [overflow-wrap:anywhere] sm:text-5xl sm:leading-[1.05] sm:tracking-tight lg:text-6xl">
                        Five objectives. <span className="text-stroke-orange">One festival.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6">
                    {OBJECTIVES.map((obj, i) => (
                        <motion.div
                            key={obj.n}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ delay: i * 0.08, duration: 0.7 }}
                            whileHover={{ y: -6, transition: { duration: 0.3 } }}
                            className={`group relative min-h-[220px] sm:min-h-[250px] rounded-3xl border border-white/10 bg-[#141414] p-5 sm:p-7 lg:p-8 hover:border-[#FF6B35]/60 transition-all duration-500 ${
                                i === 0 ? "lg:col-span-1" : ""
                            }`}
                            data-testid={`objective-card-${i}`}
                        >
                            <div className="font-display text-4xl sm:text-5xl font-black gradient-text">{obj.n}</div>
                            <div className="mt-5 sm:mt-6 max-w-full font-display text-base sm:text-lg font-bold tracking-normal break-words [overflow-wrap:anywhere]">{obj.title}</div>
                            <p className="mt-3 text-sm text-zinc-400 leading-relaxed [overflow-wrap:anywhere]">{obj.copy}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
